/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Method_3Inputs */

const en_fw_bm_method_3 = /** @type {(inputs: Fw_Bm_Method_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users who opt out in settings are excluded from the query itself, not filtered afterwards.`)
};

const id_fw_bm_method_3 = /** @type {(inputs: Fw_Bm_Method_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengguna yang menolak lewat pengaturan dikecualikan dari kuerinya sendiri, bukan disaring belakangan.`)
};

/**
* | output |
* | --- |
* | "Users who opt out in settings are excluded from the query itself, not filtered afterwards." |
*
* @param {Fw_Bm_Method_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_method_3 = /** @type {((inputs?: Fw_Bm_Method_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Method_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_method_3(inputs)
	return en_fw_bm_method_3(inputs)
});